import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Building2 } from "lucide-react";
import useProjectStatus from "../../../store/builders/useProjectStatus";

const ProjectHoldCard = () => {
  const navigate = useNavigate();
  const { projects, fetchProjects, isLoading, error } = useProjectStatus();

  useEffect(() => {
    fetchProjects("hold");
  }, [fetchProjects]);

  const handlenavigate = (name, path) => {
    navigate(path);
  };

  if (error) {
    return <p className="text-center text-red-500 text-sm">{error}</p>;
  }

  if (isLoading) {
    return <p className="text-center text-gray-500 text-sm">Loading projects...</p>;
  }

  if (projects.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-600 text-sm">
          Currently, there are no projects on hold in your portfolio. All your
          projects are proceeding as scheduled.
        </p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-2 sm:px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-16">
        {projects.map((project) => (
          <div
            key={project._id}
            className="bg-white rounded-xl shadow-md p-4 sm:p-6 relative w-full mx-auto"
          >
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src="/assets/DUCKTAIL-HOMELOAN.aviF"
                  alt="Building"
                  className="w-full h-full object-cover"
                />
              </div>

            <div className="flex-1">
              <h2 className="text-sm font-semibold text-gray-900 truncate">
                {project.builder_company || "Unknown Builder"}
              </h2>
              <div className="flex items-center gap-1 mt-0.5">
                <Building2 className="w-3 h-3 text-gray-600" />
                <span className="text-xs text-gray-600 truncate">
                  {project.project_location || "N/A"}
                </span>
              </div>
              <div className="mt-0.5">
                <span className="text-xs text-gray-600 truncate">
                  {project.project_name || "N/A"}
                </span>
              </div>
            </div>
          </div>

          <div className="mt-3 mb-10 bg-gray-50 p-2 rounded-lg max-h-40 overflow-y-auto">
            <h3 className="text-xs font-semibold mb-1">Hold Comments History</h3>
            <div className="space-y-1">
              {project.holds?.map((hold, index) => (
                <div key={index} className="border-b border-gray-200 pb-1">
                  <p className="text-xs text-gray-800">{hold.comment}</p>
                  <p className="text-[10px] text-gray-500 mt-0.5">
                    {new Date(hold.created_at).toLocaleString()}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="absolute bottom-2 right-3 flex gap-2">
            <button
              className="w-20 px-2 py-1 bg-white border border-gray-900 rounded-md text-xs text-gray-900 font-medium hover:bg-gray-50 flex items-center justify-center gap-1"
              onClick={() => handlenavigate("Chat", "/customer/chatbox")}
            >
              💬 Chat
            </button>
            <button
              className="w-20 px-2 py-1 bg-white border border-gray-900 rounded-md text-xs text-gray-900 font-medium hover:bg-gray-50 flex items-center justify-center gap-1"
              onClick={() => handlenavigate("payment", "/customer/paymenthistory")}
            >
              ₹ Payment
            </button>
            <button
              className="w-20 px-2 py-1 bg-white border border-gray-900 rounded-md text-xs text-gray-900 font-medium hover:bg-gray-50 flex items-center justify-center gap-1"
              onClick={() => handlenavigate("documents", "/customer/requestcard")}
            >
              📄 Docs
            </button>
          </div>
        </div>
      ))}
    </div>
    <button
        className="fixed bottom-3 right-3 w-12 h-12 sm:w-14 sm:h-14 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors shadow-lg"
        onClick={() => navigate("/customer/help")}
      >
        <img src="/assets/Support.png" alt="Icon" className="w-7 h-7 sm:w-9 sm:h-9" />
      </button>
  </div>
  );
};

export default ProjectHoldCard;
